import { IMAGES } from "../constants/images";
import { useRef, useState } from "react";
import { ROUTES } from "../App";
import useMoveTo from "../constants/navigation";


const OTPVerification = () => {
    const navigate = useMoveTo();
    const [otp, setOtp] = useState(Array(6).fill(""));
    const inputsRef = useRef([]);

    const handleChange = (value, index) => {
        if (/^\d$/.test(value) || value === "") {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Auto focus next input
            if (value !== "" && index < 5) {
                inputsRef.current[index + 1]?.focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && otp[index] === "" && index > 0) {
            inputsRef.current[index - 1]?.focus();
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        navigate(ROUTES.SIGN_IN);
    };

    return (
        <div className="bg-main w-full flex items-center justify-center px-4 sm:px-6 md:px-8 py-12">
            <div className="w-full max-w-md mt-20">
                {/* Header */}
                <div className="text-center mb-8">
                    <h3 className="text-2xl md:text-4xl font-bold text-white mb-2">
                        Enter OTP
                    </h3>
                    <p className="text-sm md:text-base text-gray-300">
                        We've sent a 6-digit verification code to your registered email or phone number.
                    </p>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="flex justify-between gap-2 sm:gap-3">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                ref={(el) => (inputsRef.current[index] = el)}
                                type="text"
                                maxLength="1"
                                inputMode="numeric"
                                className="input-main w-10 h-16 md:h-20 mb-6"
                                value={digit}
                                onChange={(e) => handleChange(e.target.value, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                            />
                        ))}
                    </div>

                    <button
                        type="submit"
                        className="btn-primary w-full"
                    >
                        Reset Password
                    </button>
                </form>

                {/* Resend OTP */}
                <div className="mt-6 text-center">
                    <p className="text-white text-[16px]">
                        Didn’t get OTP?{' '}
                        <button
                            onClick={() => navigate(ROUTES.SIGN_UP)}
                            className="text-primary font-semibold"
                        >
                            Resend OTP
                        </button>
                    </p>
                </div>
            </div>
        </div>

    );
};

export default OTPVerification;